import ChargeCenter from '@/app/routes/ChargeCenter';
import { chargeCenterRoute } from '@/modules/charge-center/route';
import { createRoute } from '@tanstack/react-router';

export const chargeCenterIndexRoute = createRoute({
  getParentRoute: () => chargeCenterRoute,
  path: '/',
  component: () => {
    return <ChargeCenter />;
  },
});
